/** Validates phone number by digit count (7–15). Returns true for empty values. */
export const isPhoneValid = (value: string | null | undefined): boolean => {
  if (!value) return true;
  const digits = value.replace(/[^\d]/g, '');
  return digits.length >= 7 && digits.length <= 15;
};
